import {NgModule} from '@angular/core';
import {PreloadAllModules, RouterModule, Routes} from '@angular/router';
import {PrivacyPolicyComponent} from "./partials/shared-modules/global/privacy-policy/privacy-policy.component";
import {
  MobilePrivacyComponent
} from "./partials/shared-modules/global/privacy-policy/mobile-privacy/mobile-privacy.component";
import {MobileGuard} from "./guards/mobile.guard";
import {AppInfoComponent} from "./partials/components/app-info/app-info.component";
import {MobileNavigationBackButtonTypeEnum} from "@interfaces/components/enums/navigation-back-button-type.enum";

const routes: Routes = [
  {path: 'app', component: AppInfoComponent},
  {path: 'privacy-policy', component: PrivacyPolicyComponent,
    data: { type: MobileNavigationBackButtonTypeEnum.ONLY_BACK }
  },
  {path: 'privacy-policy/:title', component: MobilePrivacyComponent, canActivate: [MobileGuard]},
  {
    path: '',
    loadChildren: () => import('./modules/user/user.module').then(m => m.UserModule)
  }
];

@NgModule({
  imports: [RouterModule.forRoot(routes,
    { initialNavigation: 'enabledBlocking',
      preloadingStrategy:PreloadAllModules
    })],
  exports: [RouterModule]
})
export class AppRoutingModule {
}
